import {getFullstackUrl} from "@/composables/useFullstackUrl";
import {getUrlWithAuth} from "@/composables/useUrlWithAuth";
import {getBrowserChoice} from "@/composables/selectedTimeZones";
const FULLSTACK = getFullstackUrl();

// #register selects both online events unless the link names one (fullstack
// usePreselectEvents.js, 2026-10-14): a Masterclass page names the Masterclass; elsewhere none
function getForParam() {
  const path = window.location.pathname.toLowerCase();
  return path.includes("masterclass") ? "masterclass" : "";
}

// tz: the zone chosen in this browser, so #register shows the same dates (fullstack Rates.vue)
function buildRegisterHash(forParam, goBackTo) {
  const path = goBackTo ?? window.location.pathname;
  const zone = getBrowserChoice();
  const tz = zone ? `&tz=${encodeURIComponent(zone)}` : "";
  const forPart = forParam ? `&for=${forParam}` : "";
  return `#register${forPart}&go_back_to=${path}${tz}`;
}

// forParam: "masterclass" or "workshop" (only that one selected), "" (both), or left out (from
// the page: a Masterclass page's, else both)
export function registrationUrl(forParam, goBackTo) {
  const eventType = forParam === undefined ? getForParam() : forParam;
  return `${FULLSTACK}/${buildRegisterHash(eventType, goBackTo)}`;
}

export function redirectToRegistration(forParam, goBackTo) {
  window.location.href = getUrlWithAuth(registrationUrl(forParam, goBackTo)); // signed in there too
}
